export default __webpack_public_path__ + "static/media/pdf.2dc99a6e.svg";